import { ButtonProps, IconProps } from '@chakra-ui/react';
import ResponsiveIconButton from '~/components/ResponsiveIconButton';
import { FEATURE_FLAGS } from '~/constants';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';

interface AgencyHeaderButtonProps extends ButtonProps {
  onClick: () => void;
  title: string;
  icon: React.ElementType<IconProps>;
  iconProps?: IconProps;
  iconOnly?: boolean;
}

const baseProps = {
  backgroundColor: 'primary.50',
  color: 'primary.700',
  size: 'md',
  fontSize: 'md',
  fontWeight: '500',
  iconSpacing: 1,
  _hover: { backgroundColor: 'primary.100' },
  _focusVisible: { backgroundColor: 'primary.100' },
  _active: { backgroundColor: 'primary.200' },
};

export const AgencyHeaderButton: React.FC<AgencyHeaderButtonProps> = ({
  title,
  icon: Icon,
  iconProps,
  iconOnly: _iconOnly,
  ...props
}) => {
  const advancedFiltersFlag = useFeatureFlag(FEATURE_FLAGS.foamAdvancedFilters);
  if (advancedFiltersFlag === 'disabled') return null;
  return (
    <ResponsiveIconButton
      {...baseProps}
      aria-label={props['aria-label'] || title}
      display="flex"
      flexDirection="row-reverse"
      width="auto"
      rounded="full"
      paddingY={{ base: 0, md: 4 }}
      paddingX={{ base: 0, md: 5 }}
      borderRadius="5xl"
      icon={Icon}
      iconColor="primary.700"
      iconProps={{
        display: { base: 'inline-block' },
        marginLeft: '0',
        marginRight: { base: 0, md: '1' },
        color: 'primary.700',
        boxSize: '18px',
        ...iconProps,
      }}
      {...props}
    >
      {title}
    </ResponsiveIconButton>
  );
};
